@if (showChangeLogBanner && hideInDetail()) {
  <div class="container">
    <div class="title">
      <img src="assets/icons/update.svg" alt="update">
      <span class="title-text" fiTranslation="UPDATE_BANNER_HEADLINE"></span>
      <button class="close-btn" (click)="closeChangeLog()">
        <img alt="Close" src="/assets/icons/close-icon.svg">
        <span class="u-hidden-visually" fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
      </button>
    </div>
    <div class="description" fiTranslation="UPDATE_BANNER_POINT_ONE" [isUpdate]="true"></div>
    <div class="description" fiTranslation="UPDATE_BANNER_POINT_TWO" [isUpdate]="true"></div>
    <div class="description" fiTranslation="UPDATE_BANNER_POINT_THREE" [isUpdate]="true"></div>
    <div class="description" fiTranslation="UPDATE_BANNER_POINT_FOUR" [isUpdate]="true"></div>
    <div class="description" fiTranslation="UPDATE_BANNER_POINT_FIVE" [isUpdate]="true"></div>
    <div class="description" fiTranslation="UPDATE_BANNER_POINT_SIX" [isUpdate]="true"></div>
    <div class="description" fiTranslation="UPDATE_BANNER_POINT_SEVEN" [isUpdate]="true"></div>
    <div class="description" fiTranslation="UPDATE_BANNER_POINT_EIGHT" [isUpdate]="true"></div>
    <div class="description" fiTranslation="UPDATE_BANNER_POINT_NINE" [isUpdate]="true"></div>
    <div class="description" fiTranslation="UPDATE_BANNER_POINT_TEN" [isUpdate]="true"></div>
  </div>
}
